import {
	type PageRequest,
	createPageRequest,
} from '@atlassian/jira-shared-types/src/rest/jira/page.tsx';
import { ITEMS_PER_PAGE, EXPAND_PARAMETERS } from '../../model/constants.tsx';
import { NAME, OWNER, FAVOURITED, POPULARITY } from '../../model/sort-field.tsx';
import { getSortField, getSortDirection, getPage } from '../../state/selectors/query/index.tsx';
import type { State } from '../../state/types.tsx';

const SORT_FIELDS = {
	[NAME]: 'NAME',
	[OWNER]: 'OWNER',
	[FAVOURITED]: 'IS_FAVOURITE',
	[POPULARITY]: 'FAVOURITE_COUNT',
} as const;

const getSort = (state: State) => ({
	direction: getSortDirection(state),
	field: SORT_FIELDS[getSortField(state)],
});

export const getServiceRequest = (state: State): PageRequest =>
	createPageRequest(getPage(state), ITEMS_PER_PAGE, getSort(state), EXPAND_PARAMETERS);
